import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';


@Injectable({providedIn: 'root'})
export class WebClientConfigurationService {

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  getPageSizeConfig() {
    return this.http.get<number>('/api/webClientConfig/getPageSizeConfig');
  }

  getPageConfig() {
    return this.http.get<any>('/api/webClientConfig/getPageConfig');
  }

}
